const chatraConfig = {
  // startHidden: true,
  colors: {
    buttonText: '#ffffff' /* chat button text color */,
    buttonBg: '#f6624A' /* chat button background color */,
  },
};

export const initLiveChat = () => {
  window.Chatra = window.Chatra || function() {};
  window.ChatraSetup = chatraConfig;
  window.addEventListener('load', () => {
    (function(d, w, c) {
      w.ChatraID = 'oZdo9BjvSnSevixTP';
      var s = d.createElement('script');
      w[c] =
        w[c] ||
        function() {
          (w[c].q = w[c].q || []).push(arguments);
        };
      s.async = true;
      s.defer = true;
      s.src = 'https://call.chatra.io/chatra.js';
      if (d.body) d.body.appendChild(s);
    })(document, window, 'Chatra');
  });
};

export const updateUserDetails = data => {
  if (!window.Chatra) {
    return;
  }
  
  try {
    window.Chatra('updateIntegrationData', data);
  } catch (err) {
    console.error(err);
  }
};

export const minimizeChatWidget = (e) => {
  e.preventDefault();
  window.Chatra('minimizeWidget');
}

export const openChatWidget = (e) => {
  e.preventDefault();
  if (!window.fcWidget) {
    return;
  }
  window.fcWidget.open();
}

// export const pageView = route => window.Chatra('pageView');



// WEBPACK FOOTER //
// ./src/livechat.js